import {makeAutoObservable} from 'mobx'
import {inject, injectable} from 'inversify'
import {TOverviewModalStore} from '@/pages/PayByLink/components/OverviewModal/TOverviewModalStore'
import {PaymentLink} from '@/api'
import {OnlinePaymentsStoreSymbol, TOnlinePaymentsStore} from '@/pages/OnlinePayments'

@injectable()
export class OverviewModalStore implements TOverviewModalStore {
    private _onlinePaymentsStore: TOnlinePaymentsStore
    public paymentLink?: PaymentLink

    constructor(@inject(OnlinePaymentsStoreSymbol) onlinePaymentsStore: TOnlinePaymentsStore) {
        this._onlinePaymentsStore = onlinePaymentsStore
        makeAutoObservable(this)
    }

    public open = false

    public setPaymentLink = (link: PaymentLink) => {
        this.paymentLink = link
    }

    public setOpen = (isOpen) => {
        this.open = isOpen
    }

    public onCancel = () => {
        this.open = false
    }

    public onOk = () => {
        this.open = false

        this._onlinePaymentsStore.openByOneTimePaymentLink(this.paymentLink)
    }
}
